// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".studentTable[data-v-779c32eb] {\n  padding: 20px;\n}\n.el-table[data-v-779c32eb]::before {\n  height: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
